// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__ox061"};